const List3GroupHeaders = {
  BOLD: 'bold',
  LARGE: 'large',
};

module.exports = List3GroupHeaders;
